import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api';
export default function ActivityTracker() {
  const location=useLocation(),path=useRef(location.pathname),activeAt=useRef(Date.now());
  const refresh=useRef(()=>{});
  const tabKey=useRef(null);
  useEffect(()=>{path.current=location.pathname;activeAt.current=Date.now();refresh.current();},[location.pathname]);
  useEffect(()=>{
    let key;
    try { if(!tabKey.current)tabKey.current=window.crypto.randomUUID?window.crypto.randomUUID():Array.from(window.crypto.getRandomValues(new Uint32Array(4)),value=>value.toString(16).padStart(8,'0')).join('');key=tabKey.current; }catch{return undefined;}
    let busy=false, stopped=false,lastToken=null,queued=false,exiting=false;
    const payload=closing=>({sessionKey:key,path:path.current,visible:!document.hidden,idleSeconds:Math.min(86400,Math.floor((Date.now()-activeAt.current)/1000)),closing});
    const close=()=>{
      const token=localStorage.getItem('authToken')||lastToken;if(!token)return;
      const origin=api.defaults?.baseURL||window.location.origin;
      try{void fetch(`${origin.replace(/\/$/,'')}/api/activity/heartbeat`,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},body:JSON.stringify(payload(true))}).catch(()=>{});}catch{/* Browser close is best effort; server timeout still marks offline. */}
      lastToken=null;
    };
    const send=async()=>{
      if(stopped)return;
      const token=localStorage.getItem('authToken');if(!token){if(lastToken)close();exiting=false;return;}if(exiting)return;
      if(busy){queued=true;return;}
      busy=true;lastToken=token;
      try{await api.post('/api/activity/heartbeat',payload(false),{timeout:8000});}catch{/* Monitoring must never interrupt the site. */}
      finally{busy=false;if(queued&&!stopped){queued=false;send();}}
    };
    const signout=()=>{exiting=true;close();};
    const touch=()=>{activeAt.current=Date.now();};
    const visible=()=>{if(!document.hidden)touch();send();};
    const shown=()=>{touch();send();};
    refresh.current=send;send();const timer=setInterval(send,30000);
    for(const event of ['pointerdown','keydown','scroll','touchstart'])window.addEventListener(event,touch,{passive:true});
    document.addEventListener('visibilitychange',visible);window.addEventListener('pageshow',shown);window.addEventListener('pagehide',close);window.addEventListener('esf-logout',signout);
    return()=>{stopped=true;refresh.current=()=>{};clearInterval(timer);for(const event of ['pointerdown','keydown','scroll','touchstart'])window.removeEventListener(event,touch);document.removeEventListener('visibilitychange',visible);window.removeEventListener('pageshow',shown);window.removeEventListener('pagehide',close);window.removeEventListener('esf-logout',signout);};
  },[]);
  return null;
}
